export default __webpack_public_path__ + "static/media/facebook.6a15fd5d.svg";